import rating from 'iz-ds-neo-alt/dist/system/i18n/vi/rating'

export default {
  ...rating,
  MSG_SEND_LOADING: 'Đang gửi lên hệ thống...',
	MSG_SEND_SUCCESS: 'Hệ thống đã nhận được đánh giá của bạn',
}